import type { ModulesAndAgendasState } from '../index';
import { findSectionIndex, findTabIndex, moveFormItemTab } from 'utils/section/tabSection';
import { recalcSectionItems } from 'utils/section/items';

interface Payload {
  currentTab: number;
  sectionName: string | null;
  fromNumber: number;
  toNumber: number;
}

export const reorderFormItemTabs = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { currentTab, sectionName, fromNumber, toNumber } = payload;

  const currentTabIndex = findTabIndex(state.tabSections, currentTab);
  if (currentTabIndex === -1) return;

  const sectionIndex = findSectionIndex(state.tabSections[currentTabIndex].sections, sectionName);
  if (sectionIndex === -1) return;

  const section = state.tabSections[currentTabIndex].sections[sectionIndex];
  const nextTabs = moveFormItemTab(section.formItemTabs, fromNumber, toNumber);
  if (!nextTabs) return;

  section.formItemTabs = nextTabs;
  section.items = recalcSectionItems(nextTabs);
};
